import React from 'react';
import PropTypes from 'prop-types';
import VideoPlayer, { VideoPlayerT } from 'components/VideoPlayer';
import ArrowButton from 'components/ArrowButton';
import classNames from 'classnames';
import Slider from 'react-slick';
import classes from './VideoPlayerListB.module.scss';

const VideoPlayerListB = (props) => {
  const { items = [] } = props;
  const arrowProps = {
    iconClassName: classes.arrow,
    type: 'ArrowButtonB',
  };
  const topColors = ['kaplan-purple', 'deep-blue-purple', 'border-blue'];

  const content = (maxSlidesToShow, containerClassName) => (
    <div className={classNames(containerClassName, { [classes.onCarouselContainer]: items.length > maxSlidesToShow })}>
      <div className={classes.wrapper}>
        <div className={classes.slidesContainer}>
          <Slider
            infinite
            speed={500}
            prevArrow={<ArrowButton {...arrowProps} />}
            nextArrow={<ArrowButton {...arrowProps} isNext />}
            pauseOnHover
            slidesToScroll={1}
            slidesToShow={items.length > maxSlidesToShow ? maxSlidesToShow : items.length}
          >
            {items.map((slide, index) => (
              <div key={index} className={classes.slide}>
                <VideoPlayer type='VideoPlayerB' item={slide} onCarousel cssClass={`border-${topColors[index % 3]}`} />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {content(1, classes.mobileContainer)}
      {content(2, classes.tabletContainer)}
      {content(3, classes.desktopContainer)}
    </>
  );
};

VideoPlayerListB.propTypes = {
  /**
   * A list of Video Player Item Objects
  */
  items: PropTypes.arrayOf(VideoPlayerT),
};

export default VideoPlayerListB;
